export default {
  pt: {
    'shipments.frenteBloco.expandSection': 'Expandir seção',
    'shipments.frenteBloco.collapseSection': 'Minimizar seção',
  },
  en: {
    'shipments.frenteBloco.expandSection': 'Expand section',
    'shipments.frenteBloco.collapseSection': 'Collapse section',
  },
  es: {
    'shipments.frenteBloco.expandSection': 'Expandir sección',
    'shipments.frenteBloco.collapseSection': 'Contraer sección',
  },
}
